import { Component } from '@angular/core';

@Component({
  selector: 'app-home-quaternary-section',
  templateUrl: './home-quaternary-section.component.html',
  styleUrls: ['./home-quaternary-section.component.css']
})
export class HomeQuaternarySectionComponent {

}
